import type {VideoSummary} from "~/lib/model/memberContent/video.server"
import type {VideoCategoryWithVideos} from "~/lib/model/memberContent/videoCategory.server"
import type {Language} from "~/locales/languages"

export const getCategoryNameForLanguage = (
  category: VideoCategoryWithVideos,
  language: Language,
): string => {
  switch (language) {
    case "en":
      return category.name
    case "es":
      return category.spanishName
  }
}

export const getCategoryDescriptionForLanguage = (
  category: VideoCategoryWithVideos,
  language: Language,
): string | null => {
  switch (language) {
    case "en":
      return category.description
    case "es":
      return category.spanishDescription
  }
}

export const getVideoTitleForLanguage = (
  video: VideoSummary,
  language: Language,
): string => {
  // For English: prefer englishTitle, then originalTitle, then spanishTitle
  // For Spanish: prefer spanishTitle, then originalTitle, then englishTitle
  switch (language) {
    case "en":
      return (
        video.englishTitle ?? video.originalTitle ?? video.spanishTitle ?? ""
      )
    case "es":
      return (
        video.spanishTitle ?? video.originalTitle ?? video.englishTitle ?? ""
      )
  }
}

export const getVideoDescriptionForLanguage = (
  video: VideoSummary,
  language: Language,
): string | null => {
  // For English: prefer englishDescription, then originalDescription, then spanishDescription
  // For Spanish: prefer spanishDescription, then originalDescription, then englishDescription
  switch (language) {
    case "en":
      return (
        video.englishDescription ??
        video.originalDescription ??
        video.spanishDescription
      )
    case "es":
      return (
        video.spanishDescription ??
        video.originalDescription ??
        video.englishDescription
      )
  }
}
